
<template>
    <div id="agReverseGeocode">
        <div class="agInputGroup agInputGroupCentered">
            <label>Connection (AGOL):</label>
            <b-form-select 
                class="agLargeInput"
                v-model="geoInput.connection" 
                :options="connections" 
                :disabled="disableUI">
            </b-form-select>
        </div>
        <label id="agReverseGeocode-creditsNote" class="agNote">ArcGIS Online credits may be charged by ESRI</label>
        <b-input-group  class="agInputGroup" prepend="Geocode URL:">
            <b-input
                class="agLargeInput"
                v-model="geoInput.config.geocodeUrl"
                type="text" 
                :disabled="disableUI">
            </b-input>
        </b-input-group >
        <ag-sub-input
            ref="location"
            :initText="geoInput.config.location"
            :type="'textarea'"
            :workflow="workflow"
            :rows="5"
            :maxRows="5"
            :noResize="true"
            :label="'Location:'"
            :disabled="disableUI">
        </ag-sub-input>
        <div class="agInputGroup agInputGroupCentered">
            <b-input-group class="agInputGroup agInputGroupInline" prepend="Distance">
                <b-input 
                    class="agMediumInput"
                    type="number" 
                    v-model="geoInput.config.distance"
                    autocomplete="false"
                    :disabled="disableUI">
                </b-input>
            </b-input-group>
        </div>
        <label class="agNote">{{`Output will be stored in field ${geoInput.shortname}.ADDRESS`}}</label>
    </div>
</template>






<script>

// components
import SubInput from "comp/ui/SubInput"

// modules

export default {
    name: "ag-geoInput-reverseGeocode",
    components: {
        "ag-sub-input": SubInput
    },
    props:{
        disableUI: Boolean,
        workflow: Object,
        geoInput: Object,
    },
    data(){
        return {
        };
    },
    computed: {

        connections() {
          var connections = [];
          var agolConnections = this.$store.getters["connStore/getAGOLConns"];
          for(var i = 0; i < agolConnections.length; i++)
          {
            var conn = agolConnections[i];
            var connItem = {value: conn, text: conn.name};
            connections.push(connItem);

            if(this.geoInput.connection && conn._id == this.geoInput.connection._id) {
              this.geoInput.connection = conn;
            }
          }
          return connections;
        },

    },
    watch: {
     
    },

    created() {

    },

    mounted() {
        this.reset();
   },

    methods: {



        // emitted Events


        // other

        reset() {
            // init config object if it's empty
            if (Object.keys(this.geoInput.config).length == 0) {
                this.geoInput.config = {
                    connection: null,
                    geocodeUrl: "http://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer",
                    location: null,
                    distance: null,
                    fields: []
                };
            }
        },

        prepareForSave() {
            this.geoInput.config.location = this.$refs["location"].text;
            this.geoInput.config.fields = ["ADDRESS"];
        },

         
    }
}

</script>






<style scoped lang="css">

#agReverseGeocode-creditsNote {
    position: relative;
    top: -15px;
    margin-bottom: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/nodes/geoInputs/ReverseGeocode.vue